import Routing from '@core/api/routing';
import { baseApi } from '@core/api/base-api';

export const computerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    computerExist: builder.query<boolean, void>({
      query: () => ({
        url: Routing.generate('rest_computer_exist', {}, true),
        method: 'HEAD',
        extraOptions: { maxRetries: 0 },
      }),
    }),
  }),
});

export const { useComputerExistQuery } = computerApi;
